import React from 'react'
import EditBtn from '../../../buttons/EditBtn'
import { NoInfo } from '../../../common/NoInfo'
import { dateToDayMonthYearFormatted } from '../../../../utils/date'

const ContactDetailComponent = ({ details, toEditContactForm, isEdit }) => {
  return (
    <div className='contact-detail mb-80'>
      <div className={'contact-detail-header'}>
        <div>
          <div className='mb-30'>
            <p className='contact-detail__sub'>Nombre</p>
            <h4 className='contact-detail__name'>{details.nombre}</h4>
          </div>
          <div className='contact-detail__info mb-20'>
            <div className='contact-detail__info-box'>
              <p className='contact-detail__sub'>Teléfono</p>
              <p className='contact-detail__text'>{details.telf}</p>
            </div>
            {/* <div>
              <p className='contact-detail__sub'>Cumpleaños</p>
              <p className='contact-detail__text'>
                {details.fechaNacimiento == null ||
                details.fechaNacimiento === ''
                  ? NoInfo('Sin fecha')
                  : dateToDayMonthYearFormatted(details.fechaNacimiento)}
              </p>
            </div> */}
          </div>
        </div>
        <div>
          <div className='mb-30'>
            <p className='contact-detail__sub'>Email</p>
            <p className='contact-detail__text'>{details.email}</p>
          </div>
          <div>
            <p className='contact-detail__sub'>Observaciones</p>
            <p className='contact-detail__text'>
              {details.observaciones
                ? details.observaciones
                : NoInfo('No hay observaciones para este contacto')}
            </p>
          </div>
        </div>
        {isEdit ? (
          <div>
            <p className='contact-detail__sub'>Editar</p>
            <div className='products__icon'>
              <div>
                <button onClick={() => toEditContactForm(details.id_Contacto)}>
                  <EditBtn />
                </button>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  )
}
export default ContactDetailComponent
